module.exports = __webpack_public_path__ + "img/normal-penguin.f9943227.svg";